import { Link } from "react-router-dom";
import { motion } from "@/lib/motion-lite";
import { ArrowRight, Map, Building2, ImageIcon, FileBadge, Waves, Terminal, Code2, Smartphone } from "lucide-react";

const TILES = [
  ["map", Map, (slug) => `/rankings/${slug}?view=map`],
  ["isp", Building2, () => "/isp"],
  ["image", ImageIcon, () => "/test"],
  ["cert", FileBadge, () => "/test"],
  ["bloat", Waves, () => "/bufferbloat"],
  ["matrix", Terminal, () => "/matrix"],
  ["widget", Code2, () => "/widget"],
  ["pwa", Smartphone, () => "/install"],
];

export function DiscoverSection({ t, lp, countrySlug }) {
  return (
    <section className="relative overflow-hidden border-y border-border bg-secondary/40" data-testid="landing-discover">
      <div className="mx-auto max-w-7xl px-4 py-16 md:px-8">
        <span className="inline-flex items-center gap-2 rounded-full border border-primary/30 bg-primary/5 px-3.5 py-1 text-xs font-700 uppercase tracking-wide text-primary">{t("disc.badge")}</span>
        <h2 className="mt-4 font-head text-3xl font-700 md:text-4xl">{t("disc.title")}</h2>
        <p className="mt-3 max-w-2xl text-muted-foreground">{t("disc.lead")}</p>
        <div className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {TILES.map(([k, Icon, to], i) => (
            <motion.div key={k} initial={{ opacity: 0, y: 16 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: (i % 4) * 0.05 }}>
              <Link to={lp(to(countrySlug))} data-testid={`discover-${k}`} className="card-hover group flex h-full flex-col rounded-2xl border border-border bg-card p-6">
                <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-primary/10 text-primary transition-colors group-hover:bg-primary group-hover:text-primary-foreground"><Icon className="h-6 w-6" /></span>
                <h3 className="mt-4 font-head text-lg font-700">{t(`disc.${k}T`)}</h3>
                <p className="mt-2 flex-1 text-sm text-muted-foreground">{t(`disc.${k}D`)}</p>
                <span className="mt-4 inline-flex items-center gap-1 text-sm font-600 text-primary">{t("disc.open")} <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" /></span>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
